module.exports = __webpack_public_path__ + "fa-regular-400.a927362a975051e5d7361d860d8ffba7.woff2";